import "./ServiceAreas.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import LocationsHero from "./sections/LocationsHero";
import ServiceAreasMap from "./sections/ServiceAreasMap";
import RequestAQuote from "./sections/RequestAQuote";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <NavigationHeader />
      <LocationsHero />
      <ServiceAreasMap />
      <RequestAQuote />
      <Footer />
    </div>;
}